import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-login-callback',
    template: 'Login...'
})
export class LoginCallbackComponent implements OnDestroy, OnInit {

    private onAuthorizationResultSubscription: Subscription;

    /**
     * Constructor
     * @param oidcSecurityService 
     */
    constructor(private router: Router) {
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
        if (this.onAuthorizationResultSubscription) {
            this.onAuthorizationResultSubscription.unsubscribe();
        }
    }
}